import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonosSection() {
  const bonos = [{
    id: '01',
    emoji: '✅',
    title: 'Checklist del Apostador',
    desc: 'El documento operativo que activa el sistema antes de cada apuesta en 30 segundos. Checklist pre-partido, checklist de análisis de las 6 capas en formato rápido, checklist de value y mercado, checklist emocional y de bankroll, checklist de confirmación final y checklist post-partido. Más 8 tarjetas de bolsillo imprimibles para tener a mano durante todo el torneo.',
    value: '$15.000'
  }, {
    id: '02',
    emoji: '📋',
    title: 'Plantilla de Análisis de Partidos',
    desc: 'La plantilla completa con las 6 capas en formato de formulario completable. Sección de datos del partido, análisis de motivación, disponibilidad del plantel, forma reciente con sistema de puntuación ponderada, estadísticas clave con calculadora de goles esperados, lectura táctica con tabla de matchups, cálculo de value integrado y registro de resultado. Más Plantilla Express y Plantilla de Resumen Semanal.',
    value: '$12.000'
  }, {
    id: '03',
    emoji: '🗓️',
    title: 'Fixture Mundial Premium',
    desc: 'Tu centro de comando durante los 39 días del Mundial. Mapa de sedes con características estratégicas, fixture completo de los 104 partidos con espacio para resultados y apuestas propias, tabla de todos los grupos actualizables, tracker de clasificados en tiempo real, seguimiento de goleadores, tracker de apuestas por jornada con P&L diario.',
    value: '$10.000'
  }, {
    id: '04',
    emoji: '📖',
    title: 'Glosario Total de Apuestas',
    desc: 'El diccionario definitivo del apostador — más de 200 términos. Glosario por categorías (fundamentos, mercados, plataformas, estadísticas, gestión, psicología, Mundial), glosario alfabético completo, 50+ términos en inglés más usados con pronunciación y traducción, expresiones coloquiales del apostador argentino. Más 6 tarjetas de referencia rápida imprimibles.',
    value: '$8.000'
  }];
  return <section className="py-20 bg-black text-white relative overflow-hidden" data-id="element-20">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/20 rounded-full blur-3xl" data-id="element-21"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-yellow-600/10 rounded-full blur-3xl" data-id="element-22"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-400/20 text-amber-400 mb-6" data-id="element-25">
            <Gift className="w-8 h-8" data-id="element-26" />
          </div>
          <h2 className="md:text-4xl font-extrabold mb-4 text-[24px]" data-id="element-27">
            🎁 4 BONUS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-amber-400 font-bold" data-id="element-28">SIEMPRE INCLUIDOS</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-29">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-zinc-900/80 border border-amber-900/40 rounded-2xl p-6 flex flex-col h-full relative overflow-hidden group hover:border-amber-500/60 transition-colors" data-id="element-30">
              <div className="absolute top-0 right-0 bg-amber-900/60 text-amber-200 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-31">
                Bonus {bono.id}
              </div>

              <div className="flex items-start gap-4 mb-4 mt-2" data-id="element-32">
                <div className="text-4xl" data-id="element-33">{bono.emoji}</div>
                <div data-id="element-34">
                  <h3 className="text-xl font-bold text-white leading-tight mb-2" data-id="element-35">
                    {bono.title}
                  </h3>
                  <p className="text-zinc-300 text-sm leading-relaxed" data-id="element-36">
                    {bono.desc}
                  </p>
                </div>
              </div>

              <div className="mt-auto pt-4 border-t border-amber-900/30 flex items-center justify-between" data-id="element-37">
                <span className="text-zinc-500 line-through text-sm" data-id="element-38">
                  Valor {bono.value}
                </span>
                <span className="text-amber-400 font-black tracking-wide" data-id="element-39">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-40">
          <div className="inline-block bg-white/10 backdrop-blur-sm border border-amber-400/30 rounded-xl px-8 py-4" data-id="element-41">
            <p className="text-lg" data-id="element-42">
              Valor total bonos{' '}
              <span className="line-through opacity-50" data-id="element-43">$45.000</span>{' '}
              <span className="text-amber-400 font-bold mx-2" data-id="element-44">→</span>{' '}
              <span className="font-black text-xl" data-id="element-45">
                GRATIS con tu Masterpack
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}